const React = require('react');

const IntervalFilterConstructor = require('../IntervalFilterConstructor');

const IntervalFilterBlock = require('./components/IntervalFilterBlock');
const SearchFilterAdmin = require('./components/SearchFilterAdmin');
const SelectFilterAdmin = require('./components/SelectFilterAdmin');
const {BtnTableGlobalDownload, BtnTableGlobalRefresh} = require('../../../AdminHelpers/Buttons');

const IntervalFilter = ({className, sort, report, update, additionalBtns, ...props}) => (
  <IntervalFilterConstructor
    {...props}
    className={"w mh-9 pt10 pb10 (lt|mb10|ph9)>1 " + className}
    TimeIntervalsComponent={IntervalFilterBlock}
    searchComponent={SearchFilterAdmin}
    selectComponent={SelectFilterAdmin}
    additionalComponents={(
      <>
        {!!update && (
          <div>
            <BtnTableGlobalRefresh
              update={update}
            />
          </div>
        )}
        {!!report && (
          <div>
            <BtnTableGlobalDownload
              filter={props.data}
              sort={sort}
              report={report}
            />
          </div>
        )}
        {additionalBtns}
      </>
    )}
  />
);

module.exports = IntervalFilter;
